import React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import { PieceIconRow } from "./FlowStepIcons";
import { TemplateTags } from "./TemplateTags";

const TemplateCard = ({ template, onClick }) => {
  const { id, name, summary, tags, pieces } = template;

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        minWidth: 0,
        transition: "transform 0.2s, border-color 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-2px)",
          borderColor: "primary.main",
          boxShadow: 2,
        },
        "@media (prefers-reduced-motion: reduce)": {
          transition: "none",
          "&:hover": { transform: "none" },
        },
      }}
    >
      <CardActionArea
        onClick={() => onClick(id)}
        sx={{ height: "100%", display: "flex", alignItems: "stretch" }}
      >
        <CardContent
          sx={{
            width: "100%",
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            p: 2.5,
            "&:last-child": { pb: 2.5 },
          }}
        >
          <Tooltip title={name} placement="top" arrow>
            <Typography
              variant="h6"
              component="h3"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                overflowWrap: "anywhere",
                fontSize: "1.1rem",
                lineHeight: 1.4,
                height: "2.8em",
              }}
            >
              {name}
            </Typography>
          </Tooltip>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              overflowWrap: "anywhere",
              fontSize: "0.875rem",
              lineHeight: 1.5,
              height: "3em",
            }}
          >
            {summary}
          </Typography>

          <Box sx={{ minHeight: 28, minWidth: 0 }}>
            <TemplateTags tags={tags} maxTags={1} compact savingsOnly />
          </Box>

          <Box
            sx={{
              mt: "auto",
              pt: 2,
              borderTop: 1,
              borderColor: "divider",
              minHeight: 20,
              display: "flex",
              alignItems: "center",
            }}
          >
            <PieceIconRow pieces={pieces} />
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default TemplateCard;
